export default "__VITE_ASSET__B_7O8_8z__"